export class QuerySanitizer {
  static #emptyString = "";
  static #blankString = " ";
  static #filePathSeparatorRegex = /\//g;
  static #parentDirRegex = /\.{2}/g;
  static #newlineRegex = /[\r\n]/g;
  #query;
  constructor(query) {
    this.#query = query;
  }
  toString() {
    return this.#query.replaceAll(QuerySanitizer.#parentDirRegex, QuerySanitizer.#emptyString).replaceAll(QuerySanitizer.#filePathSeparatorRegex, QuerySanitizer.#emptyString).replaceAll(QuerySanitizer.#newlineRegex, QuerySanitizer.#blankString);
  }
}